module.exports = __webpack_public_path__ + "img/logo-header.4902d8be.png";